<template>
  <Layout>
    <div class="mc-invoice">
      <PageHeader :title="title" :sub-title="subtitle">
        <template #afterTitle>
          <div class="d-flex gap-2">
            <McButton
              variant="secondary"
              icon="icon-outline_arrow-left"
              :text="$t('global.back')"
              @click="$refs['mc-modal-cancel'].show()"
            />
            <b-modal
            class="mc-modal"
            id="mc-modal-cancel"
            ref="mc-modal-cancel"
            :title="$t('global.action.cancel')"
            size="md"
            centered
            scrollable
          >
            <div class="card-body p-2">
              <p>{{ $t('global.text.modal.leavePage') }}?</p>
              <p><b>{{ $t('global.confirmation.sure') }}</b></p>
            </div>
            <template #modal-footer="{ cancel }">
              <div class="d-flex mx-0">
                <McButton @click="handleExitPage" variant="secondary" class="me-2" :text="$t('global.confirmation.exitPage')" />
                <McButton @click="cancel()" variant="primary" :text="$t('global.confirmation.stayPage')" />
              </div>
            </template>
          </b-modal>
            <McButton
              variant="primary"
              type="submit"
              ref="save-button-ref"
              icon="icon-outline_save"
              :text="$t('global.save')"
            />
          </div>
        </template>
      </PageHeader>
      <McWizard :items="wizardItems" :activeKey="''" class="mc-wizard" />

      <FormulateForm v-model="formValues" ref="formRef" class="mc-form" :errors="formErrors">
        <div class="mc-header__invoice-info">
          <h4 class="card-title">{{ $t('invoice.title.generalInfo') }}</h4>
        </div>
        <b-card class="mc-invoice-info__card">
          <b-row>
            <b-col cols="8">
              <ReadOnly :items="readOnlyItems" />
            </b-col>
            <b-col cols="4">
              <FormulateInput
                  v-bind="customField"
                  :ref="`${customField.name}-ref`"
                  class="mc-invoice-info__input"
                  validation-behavior="live"
                  error-behavior="value"
                />
            </b-col>
          </b-row>
          <b-row class="g-0">
            <div class="mc-invoice-info__input-group">
              <div v-for="field in fields" :key="field.name">
                <FormulateInput
                  v-bind="field"
                  :ref="`${field.name}-ref`"
                  class="mc-invoice-info__input"
                  validation-behavior="live"
                  error-behavior="value"
                  :fullObject.sync="invoiceObj"
                  :help="field?.validation?.includes('required')"
                />
              </div>
            </div>
          </b-row>
        </b-card>
      </FormulateForm>

      <ServiceCost :hasSalesOrder="hasSalesOrder" />
      <Delivery />
      <ModalBranchList
        v-if="modalBranch"
        :value.sync="modalBranch"
      />
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButton from '@/components/McButton'
import McWizard from '@/components/McWizard'

import ServiceCost from './components/ServiceCost'
import Delivery from './components/Delivery'
import ModalBranchList from './components/Branch/ModalBranchList'
import ReadOnly from './components/ReadOnly.vue'

import { wizardStatusItems } from './lib/constants/wizard-status-items'

import { fields } from './lib/fields/generalInfoFields'

export default {
  page: {
    title: 'Invoice Form',
    meta: [{ name: 'description', content: appConfig.description}]
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    McWizard,
    Delivery,
    ServiceCost,
    ModalBranchList,
    ReadOnly
  },
  mixins: [fields],
  data() {
    return {
      formValues: {},
      formErrors: {},
      invoiceObj: {},
      
      isLoading: false,
      modalBranch: [],

      //TODO change later for implementation
      hasSalesOrder: false,
    }
  },
  computed: {
    title() {
      return this.$t('invoice.title.invoiceForm')
    },
    subtitle() {
      return this.$t('invoice.subtitle.invoiceForm')
    },
    wizardStatusItems() {
      return wizardStatusItems(this)
    },
    wizardItems() {
      return [
        this.wizardStatusItems.DRAFT,
        this.wizardStatusItems.ISSUED,
        this.wizardStatusItems.PAID
      ]
    },
    readOnlyItems() {
      return [
        {
          label: this.$t('invoice.fields.invoiceNumber'),
          value: this.invoice || this.$t('global.text.automaticallyIssued'),
          bold: true,
        },
        {
          label: this.$t('invoice.fields.customer'),
          value: this.customer?.name || '-',
          bold: true,
        },
      ]
    },
    customField(){
      return {
        key: 'reference_number',
        name: 'reference_number',
        label: this.$t('invoice.fields.referenceNumber'),
        placeholder: this.$t('invoice.placeholder.referenceNumber'),
        type: 'text'
      }
    }
  },
  methods: {
    handleExitPage() {
      this.$router.back()
    },
  }
}
</script>
<style lang="scss" scoped>
.mc-invoice {
  .mc-wizard{
    display: inline-block;
    width: 100%;
    margin-bottom: 40px;
    max-width: 300px;
  }

  .mc-header__invoice-info {
    margin-bottom: 12px;
  }
  .mc-header__invoice-info,
  .mc-invoice-info__card {
    display: inline-block;
    margin-top: 0px;
    width: 100%;
  }
  .mc-invoice-info__input-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 12px;
    margin-bottom: 20px;
    justify-content: space-between;
  }
  .mc-assignment-info__input {
    width: 100%;
    padding: 0px;
  }
}
</style>